function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 39,
  height: 39,
  fill: "url(#pattern0)"
});
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "pattern0",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image0_2827_106386",
  transform: "scale(0.0104167)"
})), /*#__PURE__*/React.createElement("image", {
  id: "image0_2827_106386",
  width: 96,
  height: 96,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAADJUlEQVR4nO3cvWoVQRjG8b8aE78QItqLFgpJKrGyE4PEzsY6oFjYWHgBIngBCn4gEbTwHhRNrC1EFGKjjeYCTJGAoh5jsQaS4zm7szM7553ZfX4w3TI77/t4ztlZdwMiIiIiIiIiIiIiIiL/mwHuAsvAOrDR8bH+rxd3gOmAvlaaAB4AvQSKTnX0gPvAuGePh5oAXidQYC5jiYZDeJhAUbmNe16dHmAGfe34jN/AVFVzd1YdAFxxPE622wVcrjrIpbHnwtfSWbNVB+xwmGQNOBC+lk5aAw6WHeASwEYza+ms0h7ru92YAjCmAIwpAGMKwJgCMKYAjCkAYwrAmAIwpgCMKQBjCsCYAjCmAIwpAGMKwJgCMKYAjHUlgMfAU+tF+LJ+wCl0vAf2AvuBjwbnD2bdwJDxDTi2pZYpRv9EdzDrJvqOHnBhQD3zI15HMOtG+o5bJTU96Tv2DcUTgJNeHYrMupE+4wXlFxhbfw/eAXs8ezMSo2jYAsWLDU3M9RU47FDX5u/BpfotGa3YzX9L8S9wDFgMnOsHcLpGbfMk+rWzVczm91+lTAKfAua72nj1CYjV/B4wN+B8J4BVj/meNVl0SmIFcLPknLPArxpzfQD2NVNuemI0/yXFGyRlrjvOtQocb6LQVDXd/C+4XaVA9cuBf4CLgfVVqaonuiab/x04VePcuyle+Rw23+2gyty0KoDKl9YGOAR8HjDXEtVfY01oTQALAWs4yfYroxXgSMB8dbQigM1bwiHOU7x7+xM4EzhXHdkH0L/ZCnEDuNbQXK6yDmDYZisnWQdQttnKRbYBuGy2cpBlAHU2W6nLLoC6m63UZReAz2YrZVEDaMPfinCpIURV/UHn78qDWclSAMYUgLExh2PWyfsPNsX+DQua3+UTsBJyAinnEsCr6KvoMJdLqGmK28mp3laoqiHpy2iXT8Ay8Cj2QrrKdRMxDjwHzkZci6/WfwKg+F+oOYrnN3vxltM9PtvoKYr7PbPAUewvUbP+BMS+j9IGuhfUZgrAmAIwpgCMKQBjCsCYAjCmAIwpAGMKwJgCMKYAjCkAYwrAmAIw9hcoUv0jRifK8QAAAABJRU5ErkJggg=="
}));
function SvgAddImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImage);
export default __webpack_public_path__ + "static/media/add-image.47f107341ae453a94c6e1b185bb219df.svg";
export { ForwardRef as ReactComponent };